import { render, staticRenderFns } from "./reservationList.vue?vue&type=template&id=450ffe22"
import script from "./reservationList.vue?vue&type=script&lang=js"
export * from "./reservationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports